import React from "react";
import { bgColors } from "./constants";
import ColorPicker from "../WYSIWYGToolbar/components/ColorPicker";
import { AbstractTooltip as Tooltip } from "../ToolTip/ToolTip";
const FillColorButton = (props: any) => {
  const { handleFormatChange } = props;
  const [isShown, setIsShown]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] =
    React.useState<boolean>(false);

  return (
    <React.Fragment>
      <div className="toolbar-btn-container">
        <button
          className="wysiwyg-toolbar-btn"
          id="border-color"
          onClick={() => setIsShown(!isShown)}
          data-tooltip-id="FillColor"
        >
          <Tooltip id="BorderColor" />
          <span className="icon-Fill_Option_1">
            <span className="path1"></span>
            <span className="path2"></span>
            <span className="path3"></span>
            <span className="path4"></span>
            <span className="path5"></span>
          </span>
        </button>
        {isShown ? (
          <ColorPicker
            isShown={isShown}
            keyValue={"backgroundColor"}
            handleFormatChange={handleFormatChange}
            setIsShown={setIsShown}
            colors={bgColors}
          />
        ) : (
          <></>
        )}
      </div>
    </React.Fragment>
  );
};

export default FillColorButton;
